module.exports = __webpack_public_path__ + "assets/img/9be011ff08fb6c197e5dabe4762f28ae.png";